import type IBlogPost from "@api/models/IBlog";
import { Group, ThemeIcon } from "@mantine/core";
import AppSkeleton from "@modules/loader/AppSkeleton";
import { IconUserEdit } from "@tabler/icons-react";

interface Props {
  blog?: IBlogPost;
}

const WrittenBy: React.FC<Props> = ({ blog }) => {
  return (
    <Group className="text-primary-dark-text text-sm" gap={5}>
      <ThemeIcon
        autoContrast
        className="text-primary-dark-text"
        variant="transparent"
      >
        <IconUserEdit />
      </ThemeIcon>
      <AppSkeleton>
        <span>Par {blog?.author}</span>
      </AppSkeleton>
    </Group>
  );
};

export default WrittenBy;
